export default __webpack_public_path__ + "static/media/Frame26.a8a2e973.png";